import { render, staticRenderFns } from "./homepage.vue?vue&type=template&id=43717260&"
import script from "./homepage.vue?vue&type=script&lang=js&"
export * from "./homepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43717260')) {
      api.createRecord('43717260', component.options)
    } else {
      api.reload('43717260', component.options)
    }
    module.hot.accept("./homepage.vue?vue&type=template&id=43717260&", function () {
      api.rerender('43717260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/homepage/homepage.vue"
export default component.exports